import { render } from "./VerifyTransferLicenceModal.vue?vue&type=template&id=5111aad8"
import script from "./VerifyTransferLicenceModal.vue?vue&type=script&lang=js"
export * from "./VerifyTransferLicenceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__